import { ActionTree } from 'vuex';
import { RootState } from '@/models/states/root-state.model';
import { FiltersSimulation, FiltersSimulationState } from '@/models/states/filters-state.model';

export const actions: ActionTree<FiltersSimulationState, RootState> = {
  updateFilters({ commit }, payload: FiltersSimulation): any {
    commit('onUpdateFilters', payload);
  },
};
